export const SET_RECOMMENDATIONS = 'SET_RECOMMENDATIONS';

export const setRecommendations = plans => dispatch => {
  dispatch({
    type: SET_RECOMMENDATIONS,
    plans
  });
};
